import * as React from 'react'
import Spinner from '@/shared/components/Spinner'
import Button, { ButtonProps } from '@/shared/components/buttons/Button'
import { ReactNode } from 'react'

type Props = {
  title: ReactNode
  href?: string
} & Omit<ButtonProps, 'children'>

export default function TextButton({
  title,
  href,
  loading = false,
  ...props
}: Props) {
  return (
    <Button href={href} loading={loading} {...props}>
      {loading && (
        <span className="mr-2">
          <Spinner size={4} />
        </span>
      )}
      {title}
    </Button>
  )
}
